import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Typography,
  Container,
  TextField,
  Switch,
  InputAdornment,
  InputLabel,
  FormControl,
  OutlinedInput,
  IconButton,
  Box,
  Toolbar,
  AppBar,
  Tabs,
  Tab,
  Dialog,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import Loginimage from "../../assets/images/succcess.svg";
import { FaCalendarAlt, FaParking, FaCreditCard, FaPencilAlt, FaTrash, FaPhoneAlt } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsHouseDoor, BsClockHistory, BsPerson, BsHeadset, BsChatDots } from "react-icons/bs";
import { Button, ButtonGroup, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import WebService from "../../Services/WebService";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Import the default styles
import moment from "moment";
import { toast } from "react-toastify";

const Addvehicles = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    watch,
    getValues,
    register,
    setValue,
    reset,
  } = useForm<any>({});

  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const EditID = queryParams.get("id");

  const isVehicleAdded = localStorage.getItem("is_vehicle");

  const [show, setShow] = useState(false);
  const [VehicleMakesList, setVehicleMakesList] = useState([]);
  const [VehicleModalList, setVehicleModalList] = useState<any>([]);
  const [StateList, setStateList] = useState([]);
  const [ColorList, setColorList] = useState([]);
  const Navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getVehicleMakesList();
    getVehicleColorList();
    getVehicleStateList();
  }, []);

  useEffect(() => {
    if (EditID) {
      getVehicleList(EditID);
    }
  }, [EditID]);

  const getVehicleList = (EditID: any) => {
    WebService.getAPI({
      action: `/api/Vehicle/List`,
    })
      .then((res: any) => {
        if (res) {
          const foundVehicle = res.find((item: any) => item.VehicleID == EditID);

          setVehicleModalList((prevList: any) => [...prevList, { PvValue: foundVehicle.VehicleModel }]);
          setTimeout(() => {
            if (foundVehicle) {
              reset(foundVehicle);
              setValue("VehicleMake", foundVehicle.VehicleMake);
              setValue("VehicleModel", foundVehicle.VehicleModel);
              setValue("PlateNumber", foundVehicle.PlateNumber);
              setValue("PlateState", foundVehicle.PlateState);
              setValue("VehicleColor", foundVehicle.VehicleColor);
              setValue("VehicleYear", String(foundVehicle.VehicleYear));
            }
          }, 50);
        }
      })
      .catch(() => {});
  };

  const getVehicleMakesList = () => {
    WebService.getAPI({
      action: `/api/Vehicle/Makes`,
    })
      .then((res: any) => {
        setVehicleMakesList(
          res.map((item: any) => {
            item.PvValue = item.PvValue.toUpperCase();
            return { ...item };
          })
        );
      })
      .catch(() => {});
  };

  const getVehicleModalsList = (makeID: any) => {
    WebService.getAPI({
      action: `/api/Vehicle/Models/${makeID}`,
    })
      .then((res: any) => {
        setVehicleModalList(
          res.map((item: any) => {
            item.PvValue = item.PvValue.toUpperCase();
            return { ...item };
          })
        );
      })
      .catch(() => {});
  };

  const getVehicleColorList = () => {
    WebService.getAPI({
      action: `/api/Vehicle/Colors`,
    })
      .then((res: any) => {
        setColorList(
          res.map((item: any) => {
            item.PvDescription = item.PvDescription.toUpperCase();
            return { ...item };
          })
        );
      })
      .catch(() => {});
  };

  const getVehicleStateList = () => {
    WebService.getAPI({
      action: `/api/Core/States`,
    })
      .then((res: any) => {
        setStateList(res);
      })
      .catch(() => {});
  };

  const onAddVehicle = (data: any) => {
    
    if (EditID) {
      const VehicleEditData = {
        VehicleId: EditID,
        VehicleMake: data.VehicleMake,
        VehicleModel: data.VehicleModel,
        PlateNumber: data.PlateNumber,
        PlateState: data.PlateState,
        VehicleColor: data.VehicleColor,
        VehicleYear: data.VehicleYear,
      };

      WebService.postAPI({
        action: `/api/Vehicle/Update`,
        body: VehicleEditData,
      })
        .then((res) => {
          toast.success("Vehicle Edit Successfully");
            Navigate("/myvehicles");
         
        })
        .catch(() => {});
    } else {
      const vehicleRequestBody = { ...data };
      console.log("vehicleRequestBody", vehicleRequestBody);

      WebService.postAPI({
        action: `/api/Vehicle/Add`,
        body: vehicleRequestBody,
      })
        .then((res) => {
          toast.success("Vehicle Added Successfully");
          localStorage.setItem("is_vehicle","true")

          if (isVehicleAdded == "true") {
            Navigate("/myvehicles");
          } else {
            Navigate("/homepage");
          }
        })
        .catch(() => {});
    }
  };

  const handleChangeVehicle = (e: any) => {
    const Data: any = VehicleMakesList.find((item: any) => item.PvValue === e.target.value);

    getVehicleModalsList(Data.PVID);
  };
console.log("isVehicleAdded",isVehicleAdded);

  return (
    <>
      <Container>
        <div className="app-container">
          {/* Sticky Header */}
          <header className="header text-white text-center d-flex justify-content-between align-items-center">
            {isVehicleAdded == "true" && (
              <Link to="/myvehicles">
                <button className="back-button backbutton">
                  <IoIosArrowRoundBack size={30} color="white" />
                </button>
              </Link>
            )}

            <div> {EditID ? "Edit" : "Add"} Vehicle</div>
            <div className=" visablityhidden">
              <button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button>{" "}
            </div>
          </header>

          <form onSubmit={handleSubmit(onAddVehicle)}>
            <Container className="mt-3 px-3 pagewrap">
              <div className="mb-3">
                <label className="form-label">Vehicle Make</label>
                <select
                  className="form-select"
                  id="VehicleMake"
                  {...register("VehicleMake", { required: "Vehicle Make is required" })}
                  onChange={(e) => handleChangeVehicle(e)}
                >
                  <option value="">Select Vehicle Make</option> {/* Default option */}
                  {VehicleMakesList.map((vehicle: any, index) => (
                    <option key={index} value={vehicle.PvValue}>
                      {vehicle.PvValue}
                    </option>
                  ))}
                </select>
                {errors.VehicleMake && (
                  <Form.Text className="mt-4  text-danger">{"VehicleMake is Required"}</Form.Text>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Modal</label>
                <select
                  className="form-select"
                  {...register("VehicleModel", { required: " Vehicle Modal is required" })}
                >
                  <option value="">Select Vehicle Modal</option> {/* Default option */}
                  {VehicleModalList.map((vehicle: any, index: any) => (
                    <option key={index} value={vehicle.PvValue}>
                      {vehicle.PvValue}
                    </option>
                  ))}
                </select>
                {errors.VehicleModel && (
                  <Form.Text className="mt-4  text-danger">{"Vehicle Model is Required"}</Form.Text>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Vehicle Plate #</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Vehicle Plate #"
                  {...register("PlateNumber", { required: "PlateNumber is required" })}
                />
                {errors.PlateNumber && (
                  <Form.Text className="mt-4  text-danger">{"Plate Number is Required"}</Form.Text>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">State</label>
                <select
                  className="form-select"
                  id="exampleSelect"
                  {...register("PlateState", { required: "PlateNumber is required" })}
                >
                  <option value="">Select State </option> {/* Default option */}
                  {StateList.map((vehicle: any, index) => (
                    <option key={index} value={vehicle}>
                      {vehicle}
                    </option>
                  ))}
                </select>
                {errors.PlateState && (
                  <Form.Text className="mt-4  text-danger">{"State is Required"}</Form.Text>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label"> Vehicle Color</label>
                <select
                  className="form-select"
                  id="exampleSelect"
                  {...register("VehicleColor", { required: " Vehicle Color is required" })}
                >
                  <option value="">Select Vehicle Color</option> {/* Default option */}
                  {ColorList.map((vehicle: any, index) => (
                    <option key={index} value={vehicle.PvDescription}>
                      {vehicle.PvDescription}
                    </option>
                  ))}
                </select>
                {errors.VehicleColor && (
                  <Form.Text className="mt-4  text-danger">{"Vehicle Color is Required"}</Form.Text>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Vehicle Year</label>
                <Controller
                  control={control}
                  name="VehicleYear"
                  rules={{ required: "Vehicle Year is required" }}
                  render={({ field }) => (
                    <ReactDatePicker
                      {...field}
                      className="form-control"
                      showYearPicker
                      dateFormat="yyyy"
                      placeholderText="Select Year"
                      onChange={(date: Date | null) => {
                        const formattedDate = date ? moment(date).format("YYYY") : "";
                        field.onChange(formattedDate); // Pass formatted date to react-hook-form
                      }}
                    />
                  )}
                />
                {errors.VehicleYear && (
                  <Form.Text className="mt-4 text-danger">{"Please Select Year"}</Form.Text>
                )}
              </div>

              <div className="mb-3 mt-4">
                <Button
                  type="submit"
                  className="btn btn-brand-1 w-100 font-bold"
                  style={{ textTransform: "none" }}
                  // onClick={handleClickOpen}
                  id="vehicle_add"
                >
                  Save
                </Button>
              </div>
            </Container>
          </form>
        </div>

        <React.Fragment>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description" className="text-center">
                <img src={Loginimage} width="78" height={78} alt="Logo" />
                <br></br>
                <h5 className="text-dark mt-3 font-bold"> Vehicle Added</h5>
                New vehicle has been successfully added.
              </DialogContentText>
              <Link to="/myvehicles" className="mt-3 d-block">
                <Button autoFocus className="w-100 btn btn-brand-1 font-bold">
                  OK
                </Button>
              </Link>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      </Container>
    </>
  );
};

export default Addvehicles;
